module.exports = {
    common: {
        "alert": "Alerta",
        "submit": "Confirmar submissão",
        "sure": "Claro.",
        "save": "Preservação",
        "ok": "Certo.",
        "cancel": "Cancelar",
        "close": "Fechar",
        "back": "Recuar.",
        "result":"Resultado",
        "connotAccessed": "A web não pode ser acessada, por favor contacte o gerente!",
        "invalid": "A página é inválida. Por favor, verifique o código QR novamente!",
        "selectPackage": "Selecione pelo menos um número de pacote corretamente",
        "increased": "O número de pessoas só pode ser aumentado!",
        "moreNeed": 'Esta tabela foi colocada em {beginNum} cópias, e {nowNum} estão atualmente adicionadas. Tem certeza de que precisa adicioná-las?',
        "orderSuccess": "A sua encomenda foi enviada com sucesso.",
        "orderstatechange": "O status do pedido mudou, por favor volte a encomendar.",
        "orderSuccessfully": "sucesso do checkout!",
        "orderFailed": "Não foi possível efectuar uma encomenda!",
        "operationFailed": "a operação falhou!",
        "addSuccessfully": "Adição com sucesso!",
        "pageInvalid": "A página é inválida, verifique novamente o código QR!",
        "deleteConfirm": "Tem a certeza de apagar este item?",
        "confirm": "Tens a certeza",
        "order":"Fazer uma encomenda",
        "submitOrder":"ordem de colocação"
    },
    login: {
        'name': "Nome",
        "telephone": "Seu telefone.",
        "begin": "Iniciar",
        "number": "Número",
        "beginTime": "Iniciar tempo",
        "anonymous": "Indique anonimamente",
        "nameNotNull": "Por favor indique o seu nome.",
        "phoneNotNull": "Introduza um número de telefone.",
        "dear": "Olá",
        "dinnerAsk":"Quantas pessoas estão a jantar, por favor??",
        "selectDinnerNum":"Selecione o número de restaurantes",
        "moreNumBtn":"mais",
        "tasteRequired":"Os seus requisitos de sabor",
        "startOrder": "Iniciar a encomenda",
        "accepetSendMsg":"Permitido receber mensagens de texto.",
    },
    buffetselect: {
        'title': "Tudo que você pode comer",
        "info": "Se tem mais de doze anos de idade, precisa pedir comida para criança s. Se for mais velho que doze, precisa pedir uma refeição adulta. Quantas pessoas devem preencher os campos de refeições do buffet abaixo",
        "next": "Próximo",
        "successTip": " Você pediu com sucesso o pacote buffet. Por favor, comece a pedir o buffet. Obrigado! Obrigado!",
        "startBuffet": "Iniciar buffet",
        "more": "Mais",
        "refresh": "Refresh succressfully",
        "moreNumber": "More number",
        "successfulOrderTip": "Sucesso",
        "packageAlreadySelectedTip": "O pacote de buffet selecionado para esta mesa é o seguinte:",
        "selectedPackagesList": "{foodName} ({quantity} porção)",
        "selectedPackagesListPlural": "{foodName} ({quantity} porções)",
        "confirmContinueOrder": "Confirmar para continuar a encomendar",
        "modifyPackageNum": "Ajustar quantidade do pacote",
    },
    unavailable: {
        "enterOrder": "Entrar no pedido",
        "contactRestaurant": "Esta mesa ainda não foi aberta. Por favor, contacte o restaurante para abrir a mesa.",
        "closedHours": "Atualmente estamos fora do horário comercial. Não é possível encomendar, tente novamente mais tarde.",
    },
    header: {
        "info": "Informação",
         "opration":"Operação",
        "cartList": "Lista de desenhos",
        "cartListDsc": "Seus pratos de carrinho de compras",
        "billList": "Lista de notas",
        "billListDsc": "Pedidos feitos",
        "modify": "Novo",
        "modifyDsc": "Novo número de pessoas",
        "artServices": "Chamar o serviço",
        "artServicesDsc": "Chamar o pessoal de serviço",
        "confirmTips": "Confirmar",
        "continueText": "Se há pratos no carrinho de compras que precisam ser confirmados antes de fazer um pedido, por favor, confirmar se continuar a retornar?",
        "humanText": "Precisa de chamar o pessoal de serviço?",
        "selectLanguage": "Seleccionar o Idioma",
        "calledService": "Você ligou para o serviço, por favor espere um momento！",
        "calledSuccessfully": "Você chamou com sucesso o serviço, por favor aguarde a equipe de serviço para atendê-lo!",
    },
    buffet: {
        "tip": "Obs. Se sobrarem mais de quatro pedaços de sushi na mesa depois de terem acabado de comer, paguem os quinze pedaços por peça, que eu adicionei ao preço ALL-You-Can-Eat.",
        "freePark": "Livre",
        "payPark": "Pay Park.",
        "recommend": "Recomendação",
        "checklist": "Lista de controlo",
        "reminder": "Lembrete",
        "next": "Próximo",
        "total": "Total",
        "share": "partilha",
        "startOrder": "Ordem de início",
        "nullOrder": "Você não enviou a sua encomenda, por favor, escolha os pratos para pedir!",
        "summary": "Resumo",
        "cartList": "Lista de desenhos",
        "history": "History",
        "served": "Servido",
        "nserved": "Não servido",
        "description": "Descrição",
    },
    orderList: {
        "all": "Todos.",
        "total": "Total",
        "refresh": "Actualizar",
        "home": "Continuar a encomendar",
        "return": "Retornar para selecionar pratos",
        "info": "Informação",
        "frist": "Primeira ordem do tempo",
        "second": "A segunda ordem",
        "third": "A terceira ordem",
        "fourth": "A quarta ordem",
        "moreth": 'Ordem pela {times} vez',
        "buffetBatches": "Lotes de buffet",
        "orderSubmitted": "A ordem está a ser submetida, por favor aguarde!",
        "submitCart": "Você não selecionou pratos ou seu parceiro confirmou enviar a lista de carrinho de compras!",
        "sendKitchen": "Enviar para a cozinha",
        "remark": "Observação",
        "choice": "escolha",
        "with": "com",
        "chooseWith": "Escolha o seu com",
        "selectOne": "Seleccionar um",
        "oneOnlyOrder": "Cada ponto de energia {num} porções.",
        "onePersonOrder": "Uma pessoa pode pedir {num} porções.",
         "maxEachTimeOrder":"A cada vez, é possível pedir no máximo {num} porções.",
        "timeLimit": "Apenas {num} de cada vez.",
        "agreeWait": "Você deve concordar com o tempo de espera antes de fazer um pedido.",
        "noDishes": "There are no dishes in the shopping cart. Please select the dishes you need before placing an order!",
        "submittedTips": "Seu pedido foi enviado ou enviado por outro parceiro. Por favor, não envie novamente.",
        "orderClosedTips": "O pedido foi fechado, por favor digitalize o código QR aqui para encomendar, obrigado!",
        "reminderTips": "A cozinha recebeu o seu lembrete. Por favor, aguarde 5 minutos antes de enviar!",
        "reminderSuccessfully": "Lembrete foi bem sucedido!",
        "selectNumber": "Você não selecionou o número de pessoas, selecione o número de pessoas e comece a encomendar！",
        "orderChangeTip": "Alteração do estado da ordem",
        "deliveryType":"entrega",
        "pickUp":"Auto- recuperação",
        "delivered":"Entrega de refeições",
        "deliveryTypeNotNull":"Selecione o método de entrega.",
        "dateNotNull":"Seleccione por favor a data da encomenda.",
        "timeNotNull":"Seleccione por favor a hora da encomenda.",
        "orderDate":"Data da encomenda",
        "orderTime":"Hora da encomenda",
        "name":"Nome",
        "telephone":"Telefone",
        "email":"Correio",
        "postNummer":"Número do posto",
        "postBy":"Nome do correio",
        "address":"Endereço pormenorizado",
        "number":"Número",
        "adult":"Adultos",
        "children":"Crianças",
        "specielle":"Observações",
        "telephoneNotNull":"Introduza um número de telefone",
        "nameNotNull":"Por favor indique o seu nome",
        "emailNotNull":"Indique por favor um email",
        "numberNotNull":"Indique por favor o número de pessoas",
        "postNummerNotNull":"Introduza o código da área de envio",
        "postByNotNull":"Insira o nome da área de envio",
        "addressNotNull":"Por favor insira o endereço do envio",
        "customerInfo":"As suas informações",
        "methodAndTime":"Entrega e Tempo",
        "orderNo":"Código de recolha",
        "deliveryFee":"Taxa de entrega das refeições",
        "orderNotNull":"You have not ordered any dishes. Please go back and select the corresponding dishes",
        "orderList":"A Minha Lista de Encomendas",
        "subAmount":"Subtotal",
        "postAmount":"Taxa de entrega das refeições",
        "emailError":"Introduza por favor o formato correcto do email",
        "confirmOrder":"Encomenda firme",
         "limitTimeTitle":"Lembrete de tempo esgotado",
        "limitTimeTips":"Seu tempo de refeição excedeu o limite estabelecido. Por favor, entre em contato com nossa equipe para atendimento. Agradecemos sua preferência!",
        "chargedOnceTips":"Apenas a primeira porção deste prato é cobrada; as adições subsequentes são gratuitas.",
        "foodMaxEachTimeOrder":"Prato {foodName} só pode ser pedido até {num} porções por pedido. Por favor, ajuste a quantidade e envie novamente. Obrigado(a)!",
        "orderingTip":"Esta mesa está em ordem, tente novamente um pouco",
        "personNum": "Número de pessoas",
        "maxiNum": "Máx. por pedido (porções)",
        "upperLimit": "Limite total (porções)",
        "selectedList": "Lista selecionada",
        "clickToSelect": "Clique para selecionar acima",
        "delete": "Excluir",
        "units": "Número de porções",
        "who": "Responsável (opcional)",
        "nullRemark": "Quem pediu",
        "needMax1": "O número de porções não pode ser menor que 1",
        "upperMaxLimit": "Excede o limite total! Máximo de porções que ainda pode pedir:",
        "oneLimit": "{user} pode pedir no máximo {maxPerPerson} porção(ões), já pediu {userUsed} porção(ões)"
    },
    result: {
        tips: "O pedido foi concluído. Por favor, verifique novamente o código QR para encomendar",
        closePage: "Fechar a página",
        errorTips:"A página de acesso está faltando, por favor, digitalize o código QR novamente para encomendar"
    }
}


// WEBPACK FOOTER //
// ./src/assets/i18n/pt.js